import React from 'react'
import { motion } from 'framer-motion';
import MinusIcon from './MinusIcon';
import PlusIcon from './PlusIcon';
import { Trans } from '@ui/i18n/trans';

interface QuestionInterface {
    question: string;
    answer: string;
    activeQuestion: string;
    setActiveQuestion: React.Dispatch<React.SetStateAction<string>>;
}

export default function Question({ question, answer, activeQuestion, setActiveQuestion }: QuestionInterface) {

    function triggerQuestion() {
        if (question == activeQuestion)
            setActiveQuestion('');
        else
            setActiveQuestion(question);
    }

    return (
        <div onClick={triggerQuestion} className='w-full cursor-pointer max-w-[768px]'>
            <div className='flex items-center justify-between'>
                <h5 className='text-[#333333] dark:text-white font-medium text-lg'><Trans message={question}/></h5>
                <span>{activeQuestion == question ? <MinusIcon /> : <PlusIcon />}</span>
            </div>
            <motion.div
                initial={false}
                animate={activeQuestion == question ? 'open' : 'closed'}
                variants={{
                    open: { height: 'auto' },
                    closed: { height: '0px' }
                }}
                transition={{ ease: 'easeOut', duration: 0.3 }}
                className='overflow-hidden'
            >
                <p className='text-[#888888] pt-8'><Trans message={answer}/></p>
            </motion.div>
        </div>
    )
}
